import Head from 'next/head'
import Image from 'next/image'
import styles from "../styles/Pages/About.module.scss"
import Topbanner from '../components/Reusable/Banner/Topbanner'
import Form from '../components/Reusable/Form/Form'
import Slider from "react-slick";
import OurBlogs from '../components/Reusable/OurBlogs/OurBlogs'
import TopBannerWithouth1 from '../components/Reusable/Banner/TopBannerWithouth1'
// import Aboutform from '../components/Reusable/Aboutform/Aboutform'

export default function AboutUs() {

    const highlights = [
        {
            icon: "/icons/adventure.svg",
            title: "Adventure Rides & Activities",
            description: "With over 20 activities, you may spend some quality time with your friends and family while having a great time at this place, which provides complete entertainment, amusement, food, and leisure."
        },
        {
            icon: "/icons/valley.svg",
            title: "Hotel with Beautiful Valley View",
            description: "Hotel with beautiful Valley view- Our hotel is surrounded by beautiful natural scenery, and the Himalayas provide a breathtaking backdrop. Spend your holidays with us, and you'll have the chance to relax in both luxury and tranquility"
        },
        {
            icon: "/icons/banquet.svg",
            title: "Banquet & Conference Hall",
            description: "We offer all the latest conveniences to ensure the success of your events and meetings, making us the obvious first option. If you're planning a destination wedding, we're the finest option since you can have it on our inside location or on our outside lawns."
        },
    ]

    const testimonial = [
        {
            name: "Aviral Mittal",
            title: "From India",
            description: "The best amusement park as well as family destination near shimla , better than mall road, enjoyable place for kids as well as adults"
        },
        {
            name: "Chetan Nagarrkar",
            title: "From India",
            description: "Good for learning skiing in season, has many other games and good for adventure sports which I didn't try. "
        },
        {
            name: "Gurpreet Kaur",
            title: "From India",
            description: "Fantabulous indoor and outdoor activities. Smash zone, 3 D cinema etc , restaurant ..too good.  Good memories."
        },
    ]

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <>
            <Head>
                <title>Adventure Resorts | Best Adventure Park in Shimla, Kufri </title>
                <meta name="description" content="Adventure Resorts, Kufri offers the best adventure park in Shimla. Top thrilling adventure activities in Kufri and experience the best Shimla adventure. Book now!" />
                <meta name="keywords" content="Best Adventure Park,
Shimla Adventure,
Kufri Fun Park,
Adventure Activities In Kufri"/>
                <link rel="icon" href="/favicon.png" />
                <link rel="canonical" href="https://www.adventureresortkufri.com/about-us" />
            </Head>
            {/* <Topbanner title={"About Us"} bgImage={"/images/about-banner.png"} target="#firstsec" /> */}
            <TopBannerWithouth1 title={"About Us"} bgImage={"/images/about-banner.png"} target="#firstsec" />

            <section className={`${styles.top_sec} common_padding`} id="firstsec">
                <div className='container'>
                    <div className='row '>
                        {highlights.map((item, index) => (
                            <div className={`${styles.highlight_child} col-md-4 common_title `} key={index}>
                                <span><Image src={item.icon} width={44} height={44} alt={item.title}></Image></span>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className={`${styles.about_main} common_padding`} >
                <div className='container'>
                    <div className={`${styles.about_main_sec} row`}>
                        <div className={`${styles.about_main_sec_left} col-md-4`}>
                            <img src='/images/about-main-img.png' alt='about image' />
                        </div>
                        <div className={`${styles.about_main_sec_right} col-sm-12 col-md-8`}>
                            <div className={`${styles.left_child} common_title`}>
                                <h1 className='common_h1'>Best Adventure Parks</h1>
                                {/* <Image src="/icons/line.svg" width={120} height={2} alt='icon'></Image> */}
                                <p>The Adventure Resorts is situated in Kufri, near Shimla, with the Himalayas serving as a crown in the backdrop. The amusement park's founder has been working in the hospitality sector for over two decades and is a firm believer in the values of dedication and persistence. It is the biggest amusement park in Himachal Pradesh, and construction on it began in 2011. In a scant 16 months, it was finished, and on August 14, 2013, it opened its gates to the public for the first time.
                                </p>
                                <p> It has over 20 activities, including slides and other entertainment attractions, to help you forget about your worries. Families and children of all ages may find their favorite foods at one of the many eateries located on the property. About 120 individuals make up our workforce, and everyone here is committed to doing a great job.</p>
                                {/* <p>Every year, around 2.5 lakh people visit us, so you can also spend some fantastic time with your friends and family and have a blast at this location as it is the ideal spot to hangout in Kufri as it gives total entertainment, amusement, food, and shopping. In addition to its natural attractions, the park is home to some of the world's finest amusement park rides.</p> */}
                                <div className='d-flex'>
                                    <div>
                                        <h3><strong>25000+</strong></h3>
                                        <h4>Visit Per Month</h4>
                                    </div>
                                    <div className='mx-3'>
                                        <h3><strong>150+
                                        </strong></h3>
                                        <h4>Awesome Team Members</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <OurBlogs /> */}

            <section className={`${styles.plan_sec} row`}>
                <div className={`${styles.plan_sec_left} col-md-4 common_title mobile_text_center`}>
                    <div className='col-md-10'>
                        <Slider {...settings} className="testi_slider">
                            {testimonial.map((item, index) => (
                                <div key={index}>
                                    <Image src="/icons/quote.svg" width={33} height={33} alt='Quote Icon'></Image>
                                    {/* <Image src="/icons/user.svg" width={50} height={50} className='mt-3 d-block' alt='User Icon'></Image> */}
                                    <p>{item.description}</p>
                                    <h2>{item.name}</h2>
                                    <h4>{item.title}</h4>
                                </div>
                            ))}
                        </Slider>
                    </div>

                </div>
                <div className={`${styles.plan_sec_right} col-md-8`}>
                    <Image src="/images/about-bottom-image.png" layout='fill' objectFit='cover' alt='About Image'></Image>
                </div>
            </section>
            <section className={`${styles.form_sec} common_padding pb-0`}>
                <div className='container'>
                    <div className='common_title text-center'>
                        <h2>Plan Your Adventure With Us</h2>
                        {/* <Image src="/icons/line.svg" width={120} height={2} alt='Icon'></Image> */}
                    </div>
                    <Form />
                </div>
            </section>
        </>
    )
}
